<template>
    <td-dialog
        :title="$t('role.AUTH_SET')"
        :before-close="closeSelectAuth"
        :visible.sync="selectAuthVisible"
        width="730px"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        top="18vh"
        append-to-body
    >
        <div>
            <tdwy-collapse
                v-if="true"
                :list="clickCollapse"
                :outActiveNames="outActiveNames"
                :menuId="menuId"
                @sendCheckAllChange="checkAllChange"
                @sendCheckList="getCheckedList"
                @getCheckedAuth="getCheckedAuth"
            ></tdwy-collapse>
        </div>
        <span slot="footer">
            <td-button type="primary" @click="saveSelectedAuth()">{{ $t('common.SAVE') }}</td-button>
            <td-button type="button" @click.native="closeSelectAuth">{{ $t('common.CANCEL') }}</td-button>
        </span>
    </td-dialog>
</template>
<script>
import rolecollapse from './rolecollapse.vue';
export default {
    // 初始化渲染
    components: {
        'tdwy-collapse': rolecollapse
    },
    props: ['selectAuthVisible', 'clickCollapse', 'selectAuthMap', 'menuId'],
    created() {
        this.tempAuthList = this.$util.clone(this.clickCollapse);
        this.buildCheckedList(this.clickCollapse);
        this.checkedList = this.$util.clone(this.tempCheckedList);
        if (this.menuId != 'others') {
            for (let ele in this.clickCollapse) {
                if (this.outActiveNames.length > 7) {
                    return;
                }
                this.outActiveNames.push(this.clickCollapse[ele].resId);
            }
        }
    },
    mounted() {},
    // 定义变量
    data() {
        return {
            resIdList: [],
            checkedList: [],
            tempCheckedList: [],
            tempAuthList: [],
            currentCpllapseCancelList: [],
            outActiveNames: []
        };
    },
    // 定义并实现方法体
    methods: {
        //拼出选中的权限资源集合
        buildCheckedList(list) {
            for (var key in list) {
                let _data = list[key];
                if (_data && _data.children && _data.children.length > 0) {
                    this.buildCheckedList(_data.children);
                }
                if (_data.checkList.length > 0) {
                    _data.checkList.forEach(element => {
                        if (this.tempCheckedList.indexOf(element) === -1) {
                            this.tempCheckedList.push(element);
                        }
                    });
                }
            }
        },

        // 关闭窗口之前需要调用的方法
        closeSelectAuth() {
            this.$emit('closeSelectAuth');
        },
        //全选反选
        checkAllChange(val, index, data) {
            this.currentCpllapseCancelList = [];
            this.handleCheckAllChange(val, index, data);
            let state = 1;
            if (val === true) {
                state = 3;
            }
            this.setCheckAllBtn(this.clickCollapse, data.sParentId, state, val);
            //判断是否存在重复选中的权限资源
            if (!data.checkAll) {
                //当前取消的资源集合
                let repeatMenuList = [];
                this.currentCpllapseCancelList.forEach(authId => {
                    this.judgeRepeatedRes(authId).forEach(menuId => {
                        repeatMenuList.push(menuId);
                    });
                });

                let clickFlag = false;
                if (this.currentCpllapseCancelList.length > 0 && repeatMenuList.length > 0) {
                    clickFlag = true;
                }

                if (clickFlag) {
                    this.$confirm(this.$t('role.AUTH_USE_IN_OTHER_MENU'), this.$t('common.TIPS'), {
                        confirmButtonText: this.$t('common.SURE'),
                        cancelButtonText: this.$t('common.CANCEL'),
                        type: 'warning'
                    })
                        .then(() => {
                            // this.setCheckAllBtnStatus(val, data);
                            this.tempCheckedList = this.$util.clone(this.checkedList);
                            this.tempAuthList = this.$util.clone(this.clickCollapse);
                            //同步删掉其他菜单中的权限资源
                            this.currentCpllapseCancelList.forEach(cancelChecked => {
                                this.$emit('deleteResByMenuId', cancelChecked, repeatMenuList);
                            });
                        })
                        .catch(() => {
                            this.checkedList = this.$util.clone(this.tempCheckedList);
                            this.clickCollapse = this.$util.clone(this.tempAuthList);
                        });
                } else {
                    // this.setCheckAllBtnStatus(val, data);
                    this.tempCheckedList = this.$util.clone(this.checkedList);
                    this.tempAuthList = this.$util.clone(this.clickCollapse);
                }
            } else {
                // this.setCheckAllBtnStatus(val, data);
                this.tempCheckedList = this.$util.clone(this.checkedList);
                this.tempAuthList = this.$util.clone(this.clickCollapse);
            }
        },
        //全选全不选
        handleCheckAllChange(val, index, data) {
            let _data = data;
            _data.checkAll = val;
            if (_data.authTypes) {
                if (!Array.isArray(_data.checkList)) {
                    _data.checkList = new Array();
                }
                if (val) {
                    //增加选中
                    for (let i = 0; i < _data.authTypes.length; i++) {
                        const element = _data.authTypes[i];
                        if (_data.checkList.indexOf(element.authId) === -1) {
                            _data.checkList.push(element.authId);
                            this.checkedList.push(element.authId);
                        }
                    }
                } else {
                    //取消选中
                    for (let j = _data.checkList.length - 1; j >= 0; j--) {
                        const elementChecked = _data.checkList[j];

                        for (let i = 0; i < _data.authTypes.length; i++) {
                            const element = _data.authTypes[i];

                            if (element.authId == elementChecked) {
                                _data.checkList.splice(j, 1);
                                this.checkedList.splice(this.checkedList.indexOf(element.authId), 1);
                                this.currentCpllapseCancelList.push(element.authId);
                            }
                        }
                    }
                }
            }
            if (_data.children) {
                for (let i = 0; i < _data.children.length; i++) {
                    const elementChild = _data.children[i];
                    this.handleCheckAllChange(val, i, elementChild);
                }
            }
        },
        setCheckAllBtn(list, sParentId, state, val) {
            for (let i in list) {
                let obj = list[i];
                if (obj.resId === sParentId) {
                    //当前check组全选，需要判断是否所有都全选，是则将父节点置为全选
                    //当前check组全不选，需要判断是否所有都全不选，是则将父节点置为非选中
                    if (obj.children) {
                        if (obj.children.length > 0) {
                            let result = { all: true, none: true, state: 1 };
                            // result = this.$emit('getCheckedStatus', obj, result);
                            result = this.getCheckedStatus(obj, result);
                            state = result.state;
                        }
                    }
                    if (obj.authTypes) {
                        if (obj.authTypes.length !== obj.checkList.length) {
                            state = 2;
                        }
                    }
                    if (state === 1) {
                        obj.checkAll = false;
                    } else if (state === 2) {
                        obj.checkAll = false;
                    } else {
                        obj.checkAll = true;
                    }
                    this.setCheckAllBtn(this.clickCollapse, obj.sParentId, state, val);
                    break;
                } else {
                    if (obj.children.length > 0) {
                        this.setCheckAllBtn(obj.children, sParentId, state, val);
                    }
                }
            }
        },
        getCheckedStatus(obj, res) {
            let result = res;
            for (let index = 0; index < obj.children.length; index++) {
                const element = obj.children[index];
                if (element.checkAll !== true) {
                    result.all = false;
                    //如果节点还有子菜单，继续判断
                    if (element.children.length > 0) {
                        result = this.getCheckedStatus(element, result);
                    }
                }
                //当前选中列表不为空，则不是全不选状态
                if (element.checkList && element.checkList.length > 0) {
                    result.none = false;
                }
            }
            if (result.all) {
                result.state = 3;
            } else {
                if (result.none) {
                    result.state = 1;
                } else {
                    result.state = 2;
                }
            }
            return result;
        },
        getCheckedList(val, checkNewest, data) {
            //判断新选中的资源是否在其他菜单存在，存在则选中
            let resId = data.resId;
            for (let index = 0; index < this.resIdList.length; index++) {
                let element = this.resIdList[index];

                if (element.resId === resId) {
                    element.optionFlg = true;
                }
            }

            let array = this.checkedList;
            for (let index = array.length - 1; index >= 0; index--) {
                // if (array[index].split(",").indexOf(resId) != -1) {
                if (array[index].split(',')[0] == resId) {
                    array.splice(index, 1);
                }
            }
            for (let index = 0; index < val.length; index++) {
                let element = val[index];
                array.push(element);
            }
            this.checkedList = array;
            //比对出取消勾选的权限
            let clickFlag = false;
            let cancelChecked = '';
            let tempList = this.$util.clone(this.tempCheckedList);
            for (let i = 0; i < tempList.length; i++) {
                let before = tempList[i];
                if (this.checkedList.indexOf(before) == -1) {
                    // clickFlag = true;
                    cancelChecked = before;
                    break;
                }
            }
            //todo  可通过ResId判断是否存在重复权限
            let repeatMenuList = this.judgeRepeatedRes(cancelChecked);
            if (cancelChecked != '' && repeatMenuList.length > 0) {
                clickFlag = true;
            }
            if (clickFlag) {
                this.$confirm(this.$t('role.AUTH_USE_IN_OTHER_MENU'), this.$t('common.TIPS'), {
                    confirmButtonText: this.$t('common.SURE'),
                    cancelButtonText: this.$t('common.CANCEL'),
                    type: 'warning'
                })
                    .then(() => {
                        this.setCheckAllBtnStatus(val, data);
                        this.tempCheckedList = this.$util.clone(this.checkedList);
                        this.tempAuthList = this.$util.clone(this.clickCollapse);
                        //同步删掉其他菜单中的权限资源
                        this.$emit('deleteResByMenuId', cancelChecked, repeatMenuList);
                    })
                    .catch(() => {
                        this.checkedList = this.$util.clone(this.tempCheckedList);
                        this.clickCollapse = this.$util.clone(this.tempAuthList);
                    });
            } else {
                this.setCheckAllBtnStatus(val, data);
                this.tempCheckedList = this.$util.clone(this.checkedList);
                this.tempAuthList = this.$util.clone(this.clickCollapse);
            }
        },
        //判断其他菜单下是否存在重复的权限资源
        judgeRepeatedRes(resAuthId) {
            let repeatMenuList = [];
            this.selectAuthMap.forEach((val, key) => {
                if (key != this.menuId) {
                    if (!Array.isArray(val)) {
                        return;
                    }
                    for (let i = 0; i < val.length; i++) {
                        if (val[i] == resAuthId) {
                            repeatMenuList.push(key);
                        }
                    }
                }
            });
            return repeatMenuList;
        },
        setCheckAllBtnStatus(val, data) {
            if (val.length === 0) {
                //全不选
                this.setCheckAllBtn(this.clickCollapse, data.resId, 1, val);
            } else if (val.length !== data.authTypes.length) {
                //半选
                this.setCheckAllBtn(this.clickCollapse, data.resId, 2, val);
            } else {
                //全选
                this.setCheckAllBtn(this.clickCollapse, data.resId, 3, val);
            }
        },
        saveSelectedAuth() {
            this.$emit('saveSelectedAuth', this.clickCollapse);
            this.closeSelectAuth();
        }
    }
};
</script>
